import { PerksModal } from "../perksModal/perksModal";
import Trophy from "../perksModal/trophy.svg";
import Image from "next/image";
export const Perks = ({
  handlePerksModal,
  perksModalIsOpen,
  customerPerks = [],
}: any) => {
  const perksDisplayText = perksNumberDisplayText(customerPerks);
  return (
    <div>
      <button
        onClick={handlePerksModal}
        className="border border-gray-300 rounded-full flex gap-2 h-[full] px-2 sm:px-6 py-2 bg-white"
      >
        <span className="flex-shrink-0 w-6 h-6">
          <Image
            src={Trophy.src}
            height={24}
            width={24}
            alt="trophy icon"
            className="w-full h-full"
          />
        </span>
        <p className="lg:flex hidden">{perksDisplayText}</p>
      </button>
      <PerksModal
        isOpen={perksModalIsOpen}
        onRequestClose={handlePerksModal}
        customerPerks={customerPerks}
      />
    </div>
  );
};

const perksNumberDisplayText = (customerPerks: any) => {
  const availablePerks = customerPerks?.filter(
    (perk: { available: boolean }) => perk.available
  );
  if (availablePerks.length > 1) {
    return `You have ${availablePerks.length} perks available!`;
  } else if (availablePerks.length === 1) {
    return "You have a perk available!";
  } else {
    return "Track your progress towards perks";
  }
};
